// #51 (Sessão 32) — moeda BR. Input do tenant é "1.500,50" (ponto milhar,
// vírgula decimal); o backend recebe decimal padrão "1500.50". Estes helpers
// fazem a ponte (parse na saída do input, format na exibição).

/**
 * Converte entrada BR (ou colada com "R$"/espaços) → string decimal "1500.50"
 * pronta pro backend. Vazio → '' (limpar). NÃO valida ≥0 (o backend valida).
 * Casos cobertos:
 *  "R$ 1.500,50" / "1.500,50" / "1500,50" → "1500.50"
 *  "1.500" (grupo de milhar) → "1500"
 *  "1500" → "1500" ; "1500.50" (ponto decimal) → "1500.50"
 */
export function parseCurrencyBR(input) {
  if (input == null) return '';
  let s = String(input).trim().replace(/r\$/i, '').replace(/\s/g, '');
  if (s === '') return '';
  if (s.includes(',')) {
    // BR: vírgula = decimal, pontos = separador de milhar
    s = s.replace(/\./g, '').replace(',', '.');
  } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
    // sem vírgula, mas pontos em grupos de 3 = milhar ("1.500" → "1500")
    s = s.replace(/\./g, '');
  }
  // sem vírgula e não-grupo-de-milhar: deixa como está (aceita ponto decimal)
  return s;
}

/**
 * Formata um número/decimal pra exibição BR: 1500.5 → "1.500,50".
 * Vazio/null/NaN → ''.
 */
export function formatCurrencyBR(value) {
  if (value == null || value === '') return '';
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (Number.isNaN(n)) return '';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
